import { create } from "zustand";
const NARROW_MQ = "(max-width: 1023.98px)";
const STORAGE_KEY = "mypos.sidebar.expanded";
const readStored = () => {
    if (typeof window === "undefined")
        return null;
    try {
        const v = window.localStorage.getItem(STORAGE_KEY);
        return v === "1" ? true : v === "0" ? false : null;
    }
    catch {
        return null;
    }
};
const writeStored = (v) => {
    if (typeof window === "undefined")
        return;
    try {
        window.localStorage.setItem(STORAGE_KEY, v ? "1" : "0");
    }
    catch {
        /* storage disabled — ignore */
    }
};
const initialExpanded = () => {
    const stored = readStored();
    if (stored !== null)
        return stored;
    if (typeof window === "undefined")
        return true;
    return !window.matchMedia(NARROW_MQ).matches;
};
export const useSidebarStore = create((set, get) => ({
    expanded: initialExpanded(),
    setExpanded: (v) => {
        writeStored(v);
        set({ expanded: v });
    },
    toggle: () => {
        const next = !get().expanded;
        writeStored(next);
        set({ expanded: next });
    },
}));
export const isNarrowViewport = () => typeof window !== "undefined" && window.matchMedia(NARROW_MQ).matches;
//# sourceMappingURL=sidebarStore.js.map